import React from "react";
import Terms from "../components/Terms";

const TermsAndCondition = () => {
  return (
    <div>
      <Terms />
    </div>
  );
};

export default TermsAndCondition;
